import Container from "@material-ui/core/Container/Container";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import ProtectedRoute from "../ProtectedRoute/ProtectedRoute";
import { IRoute, IRouteAdmin } from "../../Routes";
import styles from "./MainContent.styles";
import { useAuthContext } from "../../../auth/AuthProvider";
import { isAdminRoute, isAnonymousRoute, isLoggedIn, isUser, isUserRoute } from "../../../utilities/userUtils";
import { PageNotFoundView } from "../../views/PageNotFoundView";
import { isRouteAvaiable } from "../../../utilities/permissionUtils";
import { useGetRoles } from "../../../hooks/useGetRole";
import { useIsUserLegallyOk } from "../../../hooks/useIsUserLegallyOk";

interface IMainContentProps extends WithStyles<typeof styles> {
    routes: IRoute[];
}

const MainContentPure: React.FunctionComponent<IMainContentProps> = ({classes, routes}: IMainContentProps) => {
    const authContext = useAuthContext();
    const userRoutes = routes.filter(route => isUserRoute(route));
    const adminRoutes: IRouteAdmin[] = routes.filter(route => isAdminRoute(route)) as IRouteAdmin[];
    const anonymousUserRoutes = routes.filter(route => isAnonymousRoute(route));
    const userId = authContext?.user?.id;
    const isUserLegalyOk = useIsUserLegallyOk(userId);
    const roles = useGetRoles();

    return (
        <div className={classes.content}>
            <Container maxWidth={false} className={classes.container}>
                <Switch>
                    {anonymousUserRoutes.map(route => (
                        <Route exact path={route.path} key={route.path}>
                            {route.component}
                        </Route>
                    ))}
                    {userRoutes.map(route => (
                        <ProtectedRoute isAuthenticated={isUser(authContext) && isUserLegalyOk} isLoading={authContext.isLoading}
                                        authenticationPath="/sign-in-or-register" exact path={route.path} key={route.path}>
                            {route.component}
                        </ProtectedRoute>
                    ))}
                    {adminRoutes.map(route => (
                        <ProtectedRoute isAuthenticated={isLoggedIn(authContext) && isRouteAvaiable(roles, route.scope) && isUserLegalyOk} isLoading={authContext.isLoading}
                                        authenticationPath="/sign-in-or-register" exact path={route.path} key={route.path}>
                            {route.component}
                        </ProtectedRoute>
                    ))}
                    <Route component={PageNotFoundView} />
                </Switch>
            </Container>
        </div>
    );
};

export const MainContent = withStyles(styles)(withRouter(MainContentPure));
